/** Shared react-select appearance (matches Chakra inputs, 8px radius). */
export const RS_CORNER = "8px";

export const reactSelectBaseStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: RS_CORNER,
    minHeight: "40px",
    borderColor: state.isFocused ? "#2563eb" : "#e2e8f0",
    boxShadow: state.isFocused
      ? "0 0 0 1px #2563eb, 0 1px 2px 0 rgb(15 23 42 / 0.04)"
      : "0 1px 2px 0 rgb(15 23 42 / 0.04)",
    "&:hover": {
      borderColor: state.isFocused ? "#2563eb" : "#cbd5e1",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: RS_CORNER,
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    boxShadow:
      "0 4px 6px -1px rgb(15 23 42 / 0.08), 0 2px 4px -2px rgb(15 23 42 / 0.06)",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "4px",
    borderRadius: RS_CORNER,
  }),
  option: (provided, state) => ({
    ...provided,
    borderRadius: "6px",
    margin: "2px 4px",
    width: "auto",
    backgroundColor: state.isSelected
      ? "#2563eb"
      : state.isFocused
        ? "#f1f5f9"
        : "transparent",
    color: state.isSelected ? "#fff" : "#1e293b",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#64748b",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1e293b",
  }),
};

export function mergeReactSelectStyles(base, extra) {
  if (!extra || typeof extra !== "object") {
    return base;
  }
  const out = { ...base };
  for (const key of Object.keys(extra)) {
    const bf = base[key];
    const ef = extra[key];
    if (typeof bf === "function" && typeof ef === "function") {
      out[key] = (provided, state) => ({
        ...bf(provided, state),
        ...ef(provided, state),
      });
    } else if (ef !== undefined) {
      out[key] = ef;
    }
  }
  return out;
}
